$(document).on("click", ".custom-review-trigger-scroll", function (e) {
    e.preventDefault(); // Prevent default behavior if needed

    $(".custom-reviews-tab-trigger").trigger("click"); // Trigger click event

    // Smooth scroll to the target element with an offset of -10px
    $("html, body").animate(
        {
            scrollTop: $(".custom-review-tab-scroll").offset().top - 10,
        },
        800 // Adjust duration as needed
    );
});



function openGorgiasChat() {
    if (typeof GorgiasChat !== "undefined" && GorgiasChat.open) {
        GorgiasChat.open();
    } else {
        console.error("GorgiasChat is not loaded yet.");
    }
}

document.addEventListener("DOMContentLoaded", function() {
  var chatButtons = document.querySelectorAll(".custom-open-chat");
  chatButtons.forEach(function(button) {
    button.addEventListener("click", openGorgiasChat);
  });
});






function initCartAddonSwiper() {
  var cartAddonSwiper = new Swiper(".custom-cart-page-slider-add-on", {
    slidesPerView: 2,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-prev-cart-addon",
      prevEl: ".swiper-button-next-cart-addon",
    },
    scrollbar: {
      el: ".swiper-pagination-cart-page-cart-addon",
      draggable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 15,
      },
      1024: {
        slidesPerView: 6,
        spaceBetween: 20,
      },
    },
  });
}


  initCartAddonSwiper();


// Call `initCartAddonSwiper()` again after AJAX refresh if needed.



function initializeRecommendedcartpageSwiper() {
  var cartAddonSwiper = new Swiper(".swiper-cart-page-recommended", {
    slidesPerView: 2, // Adjust based on your design
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next-cart-recommended",
      prevEl: ".swiper-button-prev-cart-recommended",
    },
    scrollbar: {
      el: ".swiper-pagination-cart-page-recommended",
      draggable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 15,
      },
      1024: {
        slidesPerView: 6,
        spaceBetween: 20,
      },
    },
  });
}




// You can call initializeCartAddonSwiper() again later as needed.


  function refreshRecommendations() {

  
    
    const recommendationsSection = document.querySelector("product-recommendations-cartpage");
        const recommendationsSection2 = document.querySelector(" .custom-tbody-cart-page");
   

    if (!recommendationsSection) return;

    const productId = recommendationsSection2.getAttribute("product-id");
    const sectionId = recommendationsSection.getAttribute("section-id");

    const recommendationsUrl =
      window.themeVariables?.routes?.productRecommendationsUrl ||
      "/recommendations/products";

    fetch(
      `${recommendationsUrl}?product_id=${productId}&limit=10&section_id=${sectionId}`
    )
      .then((response) => response.text())
      .then((html) => {
        const div = document.createElement("div");
        div.innerHTML = html;
        const newRecommendations = div.querySelector("product-recommendations-cartpage");

        if (newRecommendations && newRecommendations.innerHTML.trim()) {
          recommendationsSection.innerHTML = newRecommendations.innerHTML;
          recommendationsSection.hidden = false;
        } else {
          recommendationsSection.hidden = true;
        }
initializeRecommendedcartpageSwiper();

     
      })
      .catch((error) =>
        console.error("Error fetching recommendations:", error)
      );
  }

  document.addEventListener("DOMContentLoaded", refreshRecommendations);



function initializeSwiperSlider(containerSelector) {
  // Check if Swiper is already initialized
  if (document.querySelector(containerSelector)) {
    const container = document.querySelector(containerSelector);

    // Destroy existing Swiper instance if it exists
    if (container.swiper) {
      container.swiper.destroy(true, true);
    }

    // Initialize Swiper
    const swiper = new Swiper(containerSelector, {
      slidesPerView: 1.5, // Adjust based on layout
      spaceBetween: 10, // Spacing between slides
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      breakpoints: {
        1024: {
          slidesPerView: 1.5,
        },
        768: {
          slidesPerView: 1.5,
        },
        480: {
          slidesPerView: 1.5,
        },
      },
      loop: false, // Infinite loop scrolling
    });

    console.log('Swiper initialized:', swiper);
    return swiper; // Return the Swiper instance if needed
  }
}

// Initialize the slider on page load
document.addEventListener('DOMContentLoaded', () => {
  initializeSwiperSlider('.swiper-container.collection-slider');
});

// Check if the URL contains '?account_redirect' and redirect if true
// if (window.location.search.includes('?account_redirect')) {
//     // Replace 'https://www.example.com' with the URL you want to redirect to
//     window.location.href = 'https://shopify.com/64405340321/account/pages/aa5a7f16-45d6-4a17-85da-0d1402b129a6?region_country=US';
// }



// $(document).ready(function() {
//     $('.cstm-data').click(function() {
//         var $customDisplay = $(this).next('.custom-product-display');
//         if ($customDisplay.is(':visible')) {
//             $customDisplay.hide();
//         } else {
//             $('.custom-product-display').hide();
//             $customDisplay.show(800);
//         }
//     });
// });

$(document).ready(function() {
      $(document).on('click', '.cutom-back-to-top-mobile', function(e) {

    e.preventDefault(); // Prevent the default action of the click
    $('html, body').animate({
      scrollTop: $('.product-grid-container').offset().top - 120 // Subtract 20px from the top position
    }, 800); // Smooth scroll to the target position
  });

});

function setHeaderCartIconAccessibility() {
  const cartLink = document.querySelector('#cart-icon-bubble');
  if (!cartLink) return;

  // Expose the openCart function globally
  window.openCart = function () {
    console.log('Opening the cart...');
    // Replace `this.open` with your cart opening logic here
    // For example:
    cartLink.click();
   setTimeout(function() {
    $("cart-drawer").removeClass("is-empty");
}, 1000); // 2000 milliseconds = 2 seconds

  };

  
}

// Call the function to initialize
setHeaderCartIconAccessibility();


     $(document).on("click", "button#predictive_atc", function() {
        var variantId = $(this).data('id');
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: {
            quantity: 1,
            id: variantId
          },
          dataType: 'json',
          success: function(cart) {
    $('#CartDrawer .drawer__inner').load(location.href + ' #CartDrawer .drawer__inner > *', function() {
        // Initialize Swiper slider once the drawer content is fully loaded
        initializeSwiperSlider('.swiper-container.collection-slider');
      });
           openCart();
        
            $('.cart-count-bubble').load(location.href + ' .cart-count-bubble > *');
       
    $("cart-drawer").removeClass("is-empty");
    

          },
          error: function(xhr, status, error) {
            console.error("Error adding product to cart:", error);
          }
        });
      });



$(document).on("click", ".addon-cart-page", function() {

  var $button = $(this); // Cache the button element
  var originalText = $button.text(); // Store the original button text
  var variantId = $button.data('id');
  
  // Change button text to "Adding..."
  $button.prop("disabled", true);

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      quantity: 1,
      id: variantId
    },
    dataType: 'json',
    success: function(cart) {
      // Load cart drawer content
      $('.cart__items').load(location.href + ' .cart__items > *', function() {
           $('.custom-cart-page-addon-on').load(location.href + ' .custom-cart-page-addon-on > *', function() {
        // Initialize Swiper slider once the drawer content is fully loaded
       initCartAddonSwiper();
      });
        
       
       refreshRecommendations();
     
      });
       $('#main-cart-footer').load(location.href + ' #main-cart-footer > *', function() {
        // Initialize Swiper slider once the drawer content is fully loaded
             setTimeout(() => {
   // updateWishlistButtons();
}, 1000);
      
      });

    
     
     

      // Update cart count bubble
      $('.cart-count-bubble').load(location.href + ' .cart-count-bubble > *');

      // Remove "is-empty" class from the cart drawer
     

      // Revert button text to the original and enable it
      $button.prop("disabled", false);
    },
    error: function(xhr, status, error) {
      console.error("Error adding product to cart:", error);

      // Revert button text to the original and enable it even on error
      $button.text(originalText).prop("disabled", false);
    }
  });
});

$(document).on("click", ".addon-cart", function() {

  var $button = $(this); // Cache the button element
  var originalText = $button.text(); // Store the original button text
  var variantId = $button.data('id');
  
  // Change button text to "Adding..."
  $button.prop("disabled", true);

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      quantity: 1,
      id: variantId
    },
    dataType: 'json',
    success: function(cart) {
      // Load cart drawer content
      $('#CartDrawer .drawer__inner').load(location.href + ' #CartDrawer .drawer__inner > *', function() {
        // Initialize Swiper slider once the drawer content is fully loaded
        initializeSwiperSlider('.swiper-container.collection-slider');
      });

      // Open the cart drawer
     

      // Update cart count bubble
      $('.cart-count-bubble').load(location.href + ' .cart-count-bubble > *');

      // Remove "is-empty" class from the cart drawer
     

      // Revert button text to the original and enable it
      $button.prop("disabled", false);
    },
    error: function(xhr, status, error) {
      console.error("Error adding product to cart:", error);

      // Revert button text to the original and enable it even on error
      $button.text(originalText).prop("disabled", false);
    }
  });
});


   function bulkAddToCart() {
    // Check if there are any selected items
    let selectedItems = $('.add-on-dropdown-item.selected[data-selected="true"]');
    if (selectedItems.length === 0) {
        console.warn('No items selected to add to cart.');
        $(".custom-add-on-trigger").trigger("click");
        return; // Exit the function if no items are selected
    }

    // Initialize an array to hold the items to add
    let items = [];

    // Loop through the selected items and prepare the array
    selectedItems.each(function() {
        let variantId = $(this).data('variantid');
        let quantity = parseInt($(this).attr('dataqty'), 10);

        if (variantId && quantity) {
            // Push the variantId and quantity into the items array
            items.push({
                id: variantId,
                quantity: quantity
            });
        } else {
            console.error('Invalid variantId or quantity for:', this);
        }
    });

    // Make a single AJAX call to add all items
    $.ajax({
        url: '/cart/add.js',
        type: 'POST',
        dataType: 'json',
        contentType: 'application/json',
        data: JSON.stringify({ items: items }),
        success: function(response) {
            console.log('Bulk added to cart:', response);
          $(".custom-add-on-trigger").trigger("click");
        },
        error: function(xhr, status, error) {
            console.error('Error adding items to cart:', error);
             $(".custom-add-on-trigger").trigger("click");
        }
    });
}




 $('.custom-button-product-add-on').on('click', function(event) {
         // Reference to the button
        const $button = $(this);

        // Add loading class and disable the button
        $button.addClass('loading').attr('disabled', true);

        // Show the spinner
       $('.custom-main-cta-atc .loading__spinner.hidden .loading__spinner').removeClass('hidden');
    
        bulkAddToCart();

  setTimeout(function() {
            $button.removeClass('loading').attr('disabled', false);
          $('.custom-main-cta-atc .loading__spinner.hidden .loading__spinner').addClass('hidden');
        }, 2000);
   
    });

// /* Cart Drawer issue when quantity is out of stock */

function refreshCartDrawer() {
  $(".drawer__inner").load("/cart .drawer__inner > *", function () {
    // add_this
     $("body").addClass("overflow-hidden");
    $(".drawer").addClass("active");
    $(".drawer").removeClass("is-empty");
  initializeSwiperSlider('.swiper-container.collection-slider');
  });
}

// Observe changes in the error message container
const errorObserver = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    if ($(".product-form__error-message").text().trim().length > 0) {
      refreshCartDrawer();
      $('.cart-count-bubble').load(location.href + ' .cart-count-bubble > *');
    }
  });
});

// Start observing the error message div for changes
const errorMessageElement = document.querySelector(
  ".product-form__error-message"
);
if (errorMessageElement) {
  errorObserver.observe(errorMessageElement, {
    childList: true,
    subtree: true,
  });
}

 /* Cart Drawer issue when quantity is out of stock */

$(document).ready(function() {
   $('.cart-count-bubble').load(location.href + ' .cart-count-bubble > *');
});


// remove-all-cart-items
function refreshCartDrawerAlldelete() {
  $(".drawer__inner").load("/cart .drawer__inner > *", function () {
        $(".drawer").addClass("active");
    $(".drawer").addClass("is-empty");
  });
}

$(document).on('click', '.remove-all-cart-items', function () {
  if (confirm('Are you sure you want to clear the cart?')) {
    $.ajax({
      type: 'POST',
      url: '/cart/clear.js',
      dataType: 'json',
      success: function () {
        console.log('Cart cleared successfully.');
        refreshCartDrawerAlldelete()
        $('.cart-count-bubble').load(location.href + ' .cart-count-bubble > *');
      },
      error: function (xhr, status, error) {
        console.error('Error clearing cart:', error);
      }
    });
  }
});


function refreshCartDrawerDeleteCartPage() {
  const cartItemsElement = document.querySelector('cart-items');
  const cartItems = document.querySelector('.cart__items');
  console.log(cartItemsElement, cartItems)
  // Check if the cartItems element exists to prevent errors
  if (cartItemsElement) {
    const cartItemsCount = cartItems.children.length;
      cartItemsElement.classList.add('is-empty');
   
  }
}


$(document).on('click', '.remove-all-cart-page', function () {
  if (confirm('Are you sure you want to clear the cart?')) {
    $.ajax({
      type: 'POST',
      url: '/cart/clear.js',
      dataType: 'json',
      success: function () {
        console.log('Cart cleared successfully.');
         $('#main-cart-footer').addClass('is-empty');
        refreshCartDrawerDeleteCartPage()
        $('.cart-count-bubble').load(location.href + ' .cart-count-bubble > *');
      },
      error: function (xhr, status, error) {
        console.error('Error clearing cart:', error);
      }
    });
  }
});
// remove-all-cart-items



// in Product page change qty should be change price
function updatepriceDom(totalprice, totalCompare) {
  let Mainprice = document.querySelectorAll(".wrap-third-column .custom-price-main-pdp")
   Mainprice.forEach((ele)=>{
   ele.innerText = `$${totalprice}`
   })
  let totalComparePrice = document.querySelector(".wrap-third-column .compare-price-custom-pdp")
   totalComparePrice.innerText = `$${totalCompare}`
}

 $(document).ready(function () {
    $("quantity-input").each(function () {
      const $wrapper = $(this);
      const $input = $wrapper.find(".quantity__input");
      const $plusBtn = $wrapper.find("button[name='plus']");
      const $minusBtn = $wrapper.find("button[name='minus']");

      const $priceContainer = $(".get-price-data-custom-add");
      const $priceDisplay = $(".wrap-third-column .custom-price-main-pdp");
      const $comparePriceDisplay = $(".wrap-third-column .compare-price-custom-pdp");

      // const unitPrice = parseFloat($priceContainer.data("price"));
      // const comparePrice = parseFloat($priceContainer.data("compare-price"));

      let unitPrice = ($priceContainer.data("price") || "").toString().replace(/,/g, "");
      let comparePrice = ($priceContainer.data("compare-price") || "").toString().replace(/,/g, "");

        // console.log(unitPrice,'unitPrice-------')
      
        // Update price based on selected variant
        const updatePricesFromVariant = () => {
            const $priceContainer = $(".get-price-data-custom-add");
            unitPrice = parseFloat(($priceContainer.data("price") || "0").toString().replace(/,/g, ""));
            comparePrice = parseFloat(($priceContainer.data("compare-price") || "0").toString().replace(/,/g, ""));
        };

        // Call it once to initialize prices
        updatePricesFromVariant();

      const updatePrice = (qty) => {
        updatePricesFromVariant()
        // console.log(unitPrice, "---------------")
      const totalPrice = (unitPrice * qty).toFixed(2);
      const totalCompare = (comparePrice * qty).toFixed(2);
    
      // Add commas for thousands
        const formattedTotalPrice = `${parseFloat(totalPrice).toLocaleString("en-US", { minimumFractionDigits: 2 })}`;
        const formattedTotalCompare = totalCompare !== "0.00" 
            ? `${parseFloat(totalCompare).toLocaleString("en-US", { minimumFractionDigits: 2 })}` 
            : "";
    
        // console.log(formattedTotalPrice, formattedTotalCompare, "00000000000----------", qty);
        updatepriceDom(formattedTotalPrice, formattedTotalCompare);
    };

      const disableButtonsTemporarily = () => {
        $plusBtn.prop("disabled", true);
        $minusBtn.prop("disabled", true);

        // Re-enable buttons after a short delay (500ms in this case)
        setTimeout(() => {
          $plusBtn.prop("disabled", false);
          $minusBtn.prop("disabled", false);
        }, 500);
      };
      const handlePlus = (e) => {
        const previousValue = this.input.value;
        updatePrice(Number(previousValue))
        // console.log(previousValue)
        updatePricesFromVariant();
      };

      const handleMinus = (e) => {
      const previousValue = this.input.value;
        updatePrice(Number(previousValue))
      };
      const handleInputChange = () => {
      const qty = parseInt($input.val()) || 1;
      if (qty < 1) $input.val(1); // Prevent 0 or negative values
      updatePrice(qty);
        updatePricesFromVariant();
    };


      // Attach event listeners
      $plusBtn.off("click").on("click", handlePlus);
      $minusBtn.off("click").on("click", handleMinus);
       $input.off("input").on("input", handleInputChange);


      // when Drower open price reset
       const $cartDrawer = $("cart-drawer");
      const observer = new MutationObserver(() => {
       if ($cartDrawer.hasClass("active")) {
          updatePrice(1);
        }
     });

      if ($cartDrawer.length) {
        observer.observe($cartDrawer[0], { attributes: true });
      }
        
    });
   
  });
// in Product page change qty should be change price



// add_this

document.addEventListener("DOMContentLoaded", function () {

  const drawer = document.querySelector(".drawer");

  function trapFocus(container) {

    const focusable = container.querySelectorAll(
      'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
    );

    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    container.addEventListener("keydown", function (e) {

      if (e.key !== "Tab") return;

      if (e.shiftKey) {

        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }

      } else {

        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }

      }

    });

  }

  function focusCartDrawer() {

    if (drawer && drawer.classList.contains("active")) {

      drawer.setAttribute("tabindex", "-1");
      drawer.focus();

      trapFocus(drawer); 

    }

  }

  if (drawer) {

    const observer = new MutationObserver(function () {

      if (drawer.classList.contains("active")) {
        setTimeout(focusCartDrawer, 100);
      }

    });

    observer.observe(drawer, {
      attributes: true,
      attributeFilter: ["class"]
    });

  }

});